import React from "react";
import Button from "Components/Button";

export const getReviewReportColumns = (props) => {
	const { confirmUndeleteReviewReport } = props;
	return [
		{
			id: "action",
			label: "Action",
			isSortable: false,
			width: "90px",
			getter: (row) => (
				<Button color="orange" onClick={() => confirmUndeleteReviewReport(row)}>
					Undelete
				</Button>
			),
		},
		{
			id: "id",
			label: "ID",
			isSortable: false,
			width: "190px",
		},
		{
			id: "reviewId",
			label: "Review ID",
			isSortable: false,
			width: "190px",
		},
		{
			id: "deletedAt",
			label: "Deleted",
			isSortable: false,
			width: "190px",
			getter: (row) => (row.deletedAt ? new Date(row.deletedAt).toLocaleString() : ""),
		},
		{
			id: "formName",
			label: "Form Name",
			isSortable: false,
		},
		{
			id: "subject",
			label: "Subject",
			isSortable: false,
		},
		{
			id: "authors",
			label: "Authors",
			isSortable: false,
			width: "1fr",
			getter: (row) => row.authors?.map((author) => author).join(", "),
		},
		{
			id: "signers",
			label: "Signers",
			isSortable: false,
			width: "1fr",
			getter: (row) => row.signers?.map((signer) => signer).join(", "),
		},
	];
};
